export default __webpack_public_path__ + "static/media/i-scan_sura.c111451c.svg";